export const CHECKED_BAGS_ONE_CLICK = 'ALT_ALT4561';
export const HIDE_THIRD_OPTION_D = 'ALT_ALT4939_D';
export const HIDE_THIRD_OPTION_M = 'ALT_ALT4939_M';

export const TRIP_DETAILS_CABIN_BAGS_DESKTOP = 'ALT_ALT4986_D';
export const TRIP_DETAILS_CABIN_BAGS_MOBILE = 'ALT_ALT4986_M';

export const NON_PRIME_MERCHANDISING = 'ALT_ALT5522_M';
export const BAGS_NAMING_CLEANUP = 'ALT_ALT5551_M';

export const SELECTED_CABIN_BAGS_REDESIGN = 'ALT_ALT5586_M';

export const aliases = [
  CHECKED_BAGS_ONE_CLICK,
  HIDE_THIRD_OPTION_D,
  HIDE_THIRD_OPTION_M,
  TRIP_DETAILS_CABIN_BAGS_DESKTOP,
  TRIP_DETAILS_CABIN_BAGS_MOBILE,
  NON_PRIME_MERCHANDISING,
  BAGS_NAMING_CLEANUP,
  SELECTED_CABIN_BAGS_REDESIGN,
];
